import { render, staticRenderFns } from "./GridWrapper.vue?vue&type=template&id=3d8c97d8"
import script from "./GridWrapper.vue?vue&type=script&lang=js"
export * from "./GridWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports